/**
 * Generated with @muse/import-icons
 * Do not edit directly
 */

import { createIcon } from '../lib/create-icon';

export const AuthorizationIcon = createIcon(
  '0 0 20 20',
  <path d="M3 4v12l8 3V1zm10 1h2v10h-2v2h4V3h-4z" />,
);
